import React from "react";

const MAP = {
  GREEN: "text-emerald-400 bg-emerald-400/10 border-emerald-400/30",
  AMBER: "text-amber-400 bg-amber-400/10 border-amber-400/30",
  RED: "text-rose-500 bg-rose-500/10 border-rose-500/30",
  Fitted: "text-emerald-400 bg-emerald-400/10 border-emerald-400/30",
  "In Stock": "text-sky-400 bg-sky-400/10 border-sky-400/30",
  New: "text-sky-400 bg-sky-400/10 border-sky-400/30",
  Removed: "text-zinc-400 bg-zinc-400/10 border-zinc-400/30",
  Scrap: "text-rose-500 bg-rose-500/10 border-rose-500/30",
  Retreadable: "text-violet-400 bg-violet-400/10 border-violet-400/30",
  Retreaded: "text-violet-400 bg-violet-400/10 border-violet-400/30",
  "Under Repair": "text-amber-400 bg-amber-400/10 border-amber-400/30",
  "Under Inspection": "text-amber-400 bg-amber-400/10 border-amber-400/30",
  Active: "text-emerald-400 bg-emerald-400/10 border-emerald-400/30",
  "Under Maintenance": "text-amber-400 bg-amber-400/10 border-amber-400/30",
  Standby: "text-sky-400 bg-sky-400/10 border-sky-400/30",
  Sold: "text-zinc-400 bg-zinc-400/10 border-zinc-400/30",
  high: "text-rose-500 bg-rose-500/10 border-rose-500/30",
  medium: "text-amber-400 bg-amber-400/10 border-amber-400/30",
  low: "text-sky-400 bg-sky-400/10 border-sky-400/30",
};

export function StatusBadge({ status, testid }) {
  const cls = MAP[status] || "text-zinc-300 bg-zinc-700/30 border-zinc-600/40";
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-semibold tabular-nums ${cls}`}>
      {status}
    </span>
  );
}
